import React from "react";
import { useDispatch } from "react-redux";
import { setIsMapAttrsReady, setMapAttr } from "../../api/redux";
import SattelitePng from "../../../../assets/imgs/sattelite.png";
import TopoPng from "../../../../assets/imgs/topo.png";
import MapnikPng from "../../../../assets/imgs/mapnik.png";

export default () => {
  const dispatch = useDispatch();

  const mapTileLayerHandler = (attr) => {
    dispatch(setIsMapAttrsReady(false));
    dispatch(setMapAttr(attr));
    setTimeout(() => {
      dispatch(setIsMapAttrsReady(true));
    }, 50);
  };

  return (
    <div className="d-flex flex-wrap justify-content-around">
      <div
        className="col-12 col-md-4 tileLayers-div"
        onClick={() => {
          mapTileLayerHandler({
            url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
            attr: 'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
          });
        }}
      >
        <img src={TopoPng} className="tileLayers" />
      </div>
      <div
        className="col-12 col-md-4 tileLayers-div"
        onClick={() => {
          mapTileLayerHandler({
            url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
            attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          });
        }}
      >
        <img src={MapnikPng} className="tileLayers" />
      </div>
      <div
        className="col-12 col-md-4 tileLayers-div"
        onClick={() => {
          mapTileLayerHandler({
            url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
            attr: "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
          });
        }}
      >
        <img src={SattelitePng} className="tileLayers" />
      </div>
    </div>
  );
};
